import React from 'react';
import { motion } from 'framer-motion';
import { Users, Car, Shield, Landmark, Briefcase, Scale } from 'lucide-react';
const services = [{
  icon: Users,
  title: 'Цивільне та сімейне право',
  description: 'Вирішення сімейних суперечок, питань спадщини та захист прав власності.',
  features: ['Розподіл майна', 'Опіка над дітьми', 'Спадкове право']
}, {
  icon: Car,
  title: 'Автоюрист та ДТП',
  description: 'Комплексний захист водіїв, допомога при ДТП та оскарження незаконних штрафів.',
  features: ['Ст. 130 КУпАП', 'Представництво при ДТП', 'Скасування штрафів']
}, {
  icon: Shield,
  title: 'Кримінальне право',
  description: 'Надійний захист від незаконних дій правоохоронних та контролюючих органів.',
  features: ['Кримінальні справи', 'Адмін. правопорушення', 'Оскарження рішень']
}, {
  icon: Landmark,
  title: 'Фінанси та борги',
  description: 'Вирішення спорів з банками, повернення боргів та допомога з пенсіями.',
  features: ['Кредитні спори', 'Повернення боргів', 'Податкове право']
}, {
  icon: Briefcase,
  title: 'Господарське право',
  description: 'Юридичний супровід бізнесу, складання та детальний аналіз договорів.',
  features: ['Трудове право', 'Аналіз договорів', 'Юридичний аудит']
}, {
  icon: Scale,
  title: 'Виконавче провадження',
  description: 'Контроль виконання рішень суду та суперечки з комунальними службами.',
  features: ['Стягнення заборгованості', 'Захист боржників', 'Суперечки з ОСББ']
}];
export function Services() {
  return <section id="services" className="py-24 px-6 bg-white" data-id="element-79">
      <div className="max-w-6xl mx-auto" data-id="element-80">
        <div className="mb-16 md:mb-24" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-zinc-900 mb-6" data-id="element-82">
            Сфери практики
          </h2>
          <p className="text-lg text-zinc-500 max-w-2xl font-light" data-id="element-83">
            Повний спектр юридичних послуг. Від детальної консультації до
            представництва ваших інтересів у суді.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-84">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-zinc-50 rounded-[2rem] p-8 border border-zinc-100 hover:bg-zinc-100/80 transition-colors duration-300" data-id="element-85">
              <div className="w-12 h-12 bg-white rounded-2xl border border-zinc-100 flex items-center justify-center mb-6" data-id="element-86">
                <service.icon className="w-5 h-5 text-zinc-700" strokeWidth={1.5} data-id="element-87" />
              </div>
              <h3 className="text-xl font-semibold text-zinc-900 mb-3 tracking-tight" data-id="element-88">
                {service.title}
              </h3>
              <p className="text-zinc-500 mb-8 text-sm leading-relaxed font-light" data-id="element-89">
                {service.description}
              </p>

              <ul className="space-y-3" data-id="element-90">
                {service.features.map((feature, fIndex) => <li key={fIndex} className="flex items-center gap-3 text-sm text-zinc-600 font-light" data-id="element-91">
                    <div className="w-1 h-1 rounded-full bg-zinc-300 shrink-0" data-id="element-92" />
                    <span data-id="element-93">{feature}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}